import { render, staticRenderFns } from "./RelServicosPorProdutor.vue?vue&type=template&id=3be85cdb"
import script from "./RelServicosPorProdutor.vue?vue&type=script&lang=js"
export * from "./RelServicosPorProdutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports